import Download from '../Download';
import Category from '../Category';

export default {
    path:      '/dokumentace',
    component: Download,
    children:  [
        {
            path:      ':slug',
            name:      'download.category',
            component: Category
        },
        {
            path:      '',
            name:      'download',
            component: Category
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/download/router/index.js